import { render, staticRenderFns } from "./LeftContent.vue?vue&type=template&id=823314a8&scoped=true&"
import script from "./LeftContent.vue?vue&type=script&lang=js&"
export * from "./LeftContent.vue?vue&type=script&lang=js&"
import style0 from "./LeftContent.vue?vue&type=style&index=0&id=823314a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823314a8",
  null
  
)

export default component.exports